export const dataTestIds = {
	completedIssuesField: 'software-board-settings-general-settings.ui.completed-issues-field.select',
};
